/**
 * BottomInfo를 숨겨야 하는 페이지 체크 (note 페이지 포함)
 * @param {string} pathname - 현재 페이지 경로
 * @param {string} baseURL - 기본 URL
 * @returns {boolean} - BottomInfo를 숨겨야 하면 true
 */
export function shouldHideBottomInfo(pathname, baseURL = '') {
  const fullPath = baseURL + pathname;

  const hiddenPaths = [
    '/login',
    '/certification',
    '/identifier',
    '/permute',
    '/full/board',
    '/payment',
    '/find-id',
    '/keypad',
    '/note',
    '/app',
    '/ai',
    '/mypage',
    '/member',
    '/class',
    '/schedule',
    '/board',
    '/setting',
    '/statistics',
    '/locker',
    '/notice',
    '/message'
  ];

  return hiddenPaths.some(path => fullPath.includes(baseURL + path));
}

/**
 * DefaultView를 숨겨야 하는 페이지 체크 (note 페이지 제외, TopBar가 보여야 함)
 * @param {string} pathname - 현재 페이지 경로
 * @param {string} baseURL - 기본 URL
 * @returns {boolean} - DefaultView를 숨겨야 하면 true
 */
export function shouldHideDefaultView(pathname, baseURL = '') {
  const fullPath = baseURL + pathname;

  const hiddenPaths = [
    '/login',
    '/certification',
    '/identifier',
    '/permute',
    '/rule/',
    '/full/board/',
    '/full/board-test/',
    '/payment',
    '/find-id',
    '/keypad',
    '/app'
  ];

  return hiddenPaths.some(path => fullPath.includes(baseURL + path));
}

